/**
 * PFS Header Keyboard Navigation
 * Enables keyboard accessibility for header navigation dropdown menus.
 *
 * - Enter or Space on a dropdown parent toggles the dropdown
 * - Escape closes the dropdown and returns focus to the parent
 * - Tab moves through dropdown items naturally in DOM order
 * - Leaving the parent li via keyboard closes the dropdown
 * - Syncs aria-expanded and aria-haspopup attributes
 */
(function () {
  'use strict';

  function initHeaderKeyboard($) {
    if (!$) return;

    function getDropdown($link) {
      var $dropdown = $link.siblings('.dropdown_container');
      if (!$dropdown.length) {
        var rel = $link.data('dropdown-rel');
        if (rel) {
          $dropdown = $link.closest('.main_nav').find('.dropdown_container[data-dropdown="' + rel + '"]');
        }
      }
      return $dropdown;
    }

    function initAria() {
      $('.menu > li > a.dropdown_link').each(function () {
        var $link = $(this);
        if (!$link.attr('aria-haspopup')) {
          $link.attr({
            'aria-haspopup': 'true',
            'aria-expanded': 'false'
          });
        }
      });
    }

    function openDropdown($link) {
      var $dropdown = getDropdown($link);
      if (!$dropdown.length) return;

      var $headerContainer = $link.closest('.main_nav_wrapper');
      $headerContainer.find('.dropdown_link.active_link').each(function () {
        var $other = $(this);
        if ($other[0] !== $link[0]) {
          closeDropdown($other);
        }
      });

      $dropdown.show();
      $link.addClass('active_link').attr('aria-expanded', 'true');
      $('.is-absolute').parent().removeClass('feature_image');
    }

    function closeDropdown($link) {
      var $dropdown = getDropdown($link);
      $dropdown.hide();
      $link.removeClass('active_link').attr('aria-expanded', 'false');
      if (!$('.dropdown_link.active_link').length) {
        $('.is-absolute').parent().addClass('feature_image');
      }
    }

    // Keyboard navigation on dropdown parent links (Enter and Space)
    // Scoped strictly to .menu > li > a.dropdown_link so Space on page body scrolls normally
    $(document).on('keydown', '.menu > li > a.dropdown_link', function (e) {
      var isEnter = e.key === 'Enter' || e.keyCode === 13;
      var isSpace = e.key === ' ' || e.key === 'Spacebar' || e.keyCode === 32;

      if (isEnter || isSpace) {
        e.preventDefault();
        var $link = $(this);
        var $dropdown = getDropdown($link);
        var isOpen = $link.attr('aria-expanded') === 'true' || $link.hasClass('active_link') || $dropdown.is(':visible');
        if (isOpen) {
          closeDropdown($link);
        } else {
          openDropdown($link);
        }
      }
    });

    $(document).on('keydown', '.menu > li > a.dropdown_link, .menu > li .dropdown_container', function (e) {
      var isEscape = e.key === 'Escape' || e.keyCode === 27;
      if (isEscape) {
        var $li = $(this).closest('li');
        var $link = $li.find('> a.dropdown_link');
        var $dropdown = getDropdown($link);
        if ($dropdown.is(':visible') || $link.attr('aria-expanded') === 'true' || $link.hasClass('active_link')) {
          e.preventDefault();
          closeDropdown($link);
          $link.focus();
        }
      }
    });

    $(document).on('focusout', '.menu > li', function () {
      var $li = $(this);
      setTimeout(function () {
        if (!$li[0].contains(document.activeElement)) {
          var $link = $li.find('> a.dropdown_link');
          if ($link.length && ($link.hasClass('active_link') || $link.attr('aria-expanded') === 'true')) {
            closeDropdown($link);
          }
        }
      }, 20);
    });

    $(document).on('mouseenter mouseover', '.menu > li > a.dropdown_link', function () {
      $(this).attr('aria-expanded', 'true');
    });

    $(document).on('mouseleave', '.menu > li', function () {
      var $link = $(this).find('> a.dropdown_link');
      var $dropdown = getDropdown($link);
      setTimeout(function () {
        if (!$dropdown.is(':visible')) {
          $link.attr('aria-expanded', 'false');
        }
      }, 50);
    });

    $(document).on('mouseleave', '.main_nav', function () {
      $('.menu > li > a.dropdown_link').each(function () {
        var $link = $(this);
        var $dropdown = getDropdown($link);
        if (!$dropdown.is(':visible')) {
          $link.attr('aria-expanded', 'false');
        }
      });
    });

    initAria();
    $(document).ready(initAria);
    $(document).on('focusin mouseenter', '.menu > li > a.dropdown_link', function () {
      if (!$(this).attr('aria-haspopup')) {
        $(this).attr({
          'aria-haspopup': 'true',
          'aria-expanded': 'false'
        });
      }
    });
  }

  if (typeof window.jQuery !== 'undefined') {
    initHeaderKeyboard(window.jQuery);
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      if (typeof window.jQuery !== 'undefined') {
        initHeaderKeyboard(window.jQuery);
      }
    });
  }
})();
